import { createFileRoute, Link } from '@tanstack/react-router'
import { ABOUT } from '../content'
import { StackSection } from '../sections'

export const Route = createFileRoute('/')({
  head: () => ({
    meta: [
      { title: 'jfrader - full-stack engineer' },
      { name: 'description', content: 'full-stack engineer. react, node, postgresql, rust, linux.' },
      { property: 'og:title', content: 'jfrader - full-stack engineer' },
      { property: 'og:description', content: 'full-stack engineer. react, node, postgresql, rust, linux.' },
      { property: 'og:url', content: 'https://jfrader.com/' },
    ],
    links: [
      { rel: 'canonical', href: 'https://jfrader.com/' }
    ]
  }),
  component: HomePage,
})

function HomePage() {
  return (
    <>
      <section className="sec">
        <h2 className="sec__label">whoami</h2>
        <div className="about">
          <p>{ABOUT[0]}</p>
        </div>
      </section>

      <StackSection />

      <section className="sec">
        <h2 className="sec__label">elsewhere</h2>
        <div className="chips" style={{ marginTop: 0 }}>
          <Link className="chip" to="/about">about</Link>
          <Link className="chip" to="/products">products</Link>
          <Link className="chip" to="/projects">projects and open source</Link>
          <Link className="chip" to="/tips">tips</Link>
          <Link className="chip" to="/contact">contact</Link>
        </div>
      </section>

    </>
  )
}
